module.exports = __webpack_public_path__ + "static/img/culture2.a1ee8538.png";